import { render, staticRenderFns } from "./NewTransferPendingDetails.vue?vue&type=template&id=5c7932b9"
import script from "./NewTransferPendingDetails.vue?vue&type=script&lang=js"
export * from "./NewTransferPendingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports